import { useContext } from "react"
import { Link } from "react-router-dom"
import { DataContext } from "../../context/dataContext"
import Loading from "../Loading"

const WorkList = () => {
    const { data } = useContext(DataContext)

    if (data === null) {
        return <Loading />
    }

    if (data.length === 0) {
        return (
            <div>
                <span >No hay trabajos</span>
            </div>
        )
    }
    return (
        <div className="mt-3">
            <div className="row">
                {data.map(work => (
                    <div className="col-md-3" key={work.id}>
                        <div className="card">
                            <div className="w-100" style={{ height: '25vh' }}>
                                <img
                                    src={work.image}
                                    style={{ objectFit: "cover", width: "100%", height: "100%" }}
                                    alt={`${work.description}`}
                                />
                            </div>
                            <div className="card-body d-flex justify-content-between align-items-center" >
                                <span className="card-title placeholder-glow">{work.title}</span>
                                <Link to={`/admin/portafolio/${work.id}`} >
                                    <span className="bi bi-arrow-right"></span>
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )

}

export default WorkList